<!--
    施工档案-交付报告数据编辑
-->
<template>
    <div v-if="type" class="details-wrap">
        <template v-if="type == 2">
            <img class="top-bg" src="@/assets/images/project/v3/top_bg.png" alt=""/>
            <div class="project-panel">
                <div class="project-name">
                    {{ projectInfo.city || '--' }} ｜ {{ projectInfo.plot_name || projectInfo.community_name || '--' }}
                </div>
                <div class="census">
                    <div class="share">
                        <img src="@/assets/images/project/v3/share_icon.png" alt="">
                        <span>{{ projectInfo.shares }}</span>
                    </div>
                    <div class="view">
                        <img src="@/assets/images/project/v3/look_blue.png" alt="">
                        <span>{{ projectInfo.real_views }}</span>
                    </div>
                </div>
                <div class="info">
                    <span v-if="projectInfo.house_area">{{ projectInfo.house_area }}㎡</span>
                    <span v-if="projectInfo.house_area && projectInfo.house_type"> ｜ </span>
                    <span v-if="projectInfo.house_type">{{
                            projectInfo.house_type + projectInfo.house_type_room
                        }}</span>
                    <span v-if="projectInfo.house_cate && (projectInfo.house_area || projectInfo.house_type_name)">
                    ｜
                </span>
                    <span v-if="projectInfo.house_cate">{{ projectInfo.house_cate }}</span>
                    <span
                        v-if="projectInfo.type && (projectInfo.house_area || projectInfo.house_type || projectInfo.house_cate)">
                    ｜
                </span>
                    <span v-if="projectInfo.type">{{ projectInfo.type }}</span>
                </div>
            </div>
        </template>
        <template v-if="type == 1">
            <div v-if="isShowDiscuss" class="discuss-msg">
                “{{ discussMsg || '很满意史密斯这次的服务，采暖、空调效果也非常好' }}”
            </div>
            <div v-if="isShowDiscuss" class="discuss-panel">
                <div v-if="userInfo" class="user-box">
                    <img :src="userInfo.img" alt="">
                    <div class="name">
                        {{ userInfo.name }}
                    </div>
                    <div class="time">
                        {{ projectInfo.city ? projectInfo.city + ' · ' : '' }}{{ userInfo.time }}
                    </div>
                </div>
                <!-- 施工 -->
                <template v-if="isUnfoldDiscuss">
                    <div v-if="discussInfo.sgInfo" class="discuss-box">
                        <div class="title">
                            <p>系统施工评价</p>
                            <vantRate v-model="discussInfo.sgInfo.score_num" readonly allow-half color="#ffd21e"
                                      void-icon="star"
                                      :size="16"
                                      void-color="#eee"></vantRate>
                            <p class="score">{{ discussInfo.sgInfo.score }}分</p>
                            <p class="time">{{ discussInfo.sgInfo.time }}</p>
                        </div>
                        <div class="content">
                            {{ discussInfo.sgInfo.content }}
                        </div>
                        <div class="img-box">
                            <template v-for="(item,index) in discussInfo.sgInfo.pic">
                                <div :class="['img-item',{'video-mask': item.type != 'image'}]">
                                    <img @click="toPreview(discussInfo.sgInfo.pic,index)" alt="'"
                                         :src="item.type == 'image' ? item.pic : item.pic+'?x-oss-process=video/snapshot,t_1000,m_fast'">
                                </div>
                            </template>
                        </div>
                        <div v-if="discussInfo.sgInfo.voice" class="audio-box" @click="playAudio('sgInfo','audio_sg')">
                            <div class="icon">
                                <img :class="['audio-icon', {'audio-icon-act':discussInfo.sgInfo.isOpenVoice}]"
                                     src="@/assets/images/project/v3/audio_icon.png"
                                     alt="">
                            </div>
                            <div class="time">
                                {{ discussInfo.sgInfo.voice_time }}s
                            </div>
                            <div class="red-dit"></div>
                            <audio id="audio_sg" ref="audio_sg" :src="discussInfo.sgInfo.voice"
                                   @ended="onAudioEnd('sgInfo')"></audio>
                        </div>
                        <div v-if="discussInfo.jgInfo || discussInfo.zpInfo" class="split"></div>
                    </div>
                </template>
                <!-- 竣工 -->
                <template v-if="discussInfo.zpInfo? isUnfoldDiscuss :true">
                    <div v-if="discussInfo.jgInfo" class="discuss-box">
                        <div class="title">
                            <p>竣工交付评价</p>
                            <vantRate v-model="discussInfo.jgInfo.score_num" readonly allow-half color="#ffd21e"
                                      void-icon="star"
                                      :size="16"
                                      void-color="#eee"></vantRate>
                            <p class="score">{{ discussInfo.jgInfo.score }}分</p>
                            <p class="time">{{ discussInfo.jgInfo.time }}</p>
                        </div>
                        <div class="content">
                            {{ discussInfo.jgInfo.content }}
                        </div>
                        <div class="img-box">
                            <template v-for="(item,index) in discussInfo.jgInfo.pic">
                                <div :class="['img-item',{'video-mask':item.type != 'image'}]">
                                    <img @click="toPreview(discussInfo.jgInfo.pic,index)" alt="'"
                                         :src="item.type == 'image' ? item.pic : item.pic+'?x-oss-process=video/snapshot,t_1000,m_fast'">
                                </div>
                            </template>
                        </div>
                        <div v-if="discussInfo.jgInfo.voice" class="audio-box" @click="playAudio('jgInfo','audio_jg')">
                            <div class="icon">
                                <img :class="['audio-icon', {'audio-icon-act':discussInfo.sgInfo.isOpenVoice}]"
                                     src="@/assets/images/project/v3/audio_icon.png" alt="">
                            </div>
                            <div class="time">
                                {{ discussInfo.jgInfo.voice_time }}s
                            </div>
                            <div class="red-dit"></div>
                            <audio id="audio_jg" ref="audio_jg" :src="discussInfo.jgInfo.voice"
                                   @ended="onAudioEnd('jgInfo')"></audio>
                        </div>
                        <div v-if="discussInfo.zpInfo" class="split"></div>
                    </div>
                </template>
                <!-- 追评 -->
                <div v-if="discussInfo.zpInfo" class="discuss-box">
                    <div class="title">
                        <p> {{ computTime(discussInfo.zpInfo.time) }}后追评 </p>
                        <p class="time">{{ '2023.02.03' }}</p>
                    </div>
                    <div class="content">
                        {{ discussInfo.zpInfo.content }}
                    </div>
                    <div class="img-box">
                        <template v-for="(item,index) in discussInfo.zpInfo.pic">
                            <div :class="['img-item',{'video-mask': item.type != 'image'}]">
                                <img @click="toPreview(discussInfo.zpInfo.pic,index)" alt="'"
                                     :src="item.type == 'image' ? item.pic : item.pic+'?x-oss-process=video/snapshot,t_1000,m_fast'">
                            </div>
                        </template>
                    </div>
                </div>
                <div v-if="isShowUnfold" class="unfold" @click="toUnfold">
                    <p> {{ isUnfoldDiscuss ? '收起评价' : '展开评论' }}</p>
                    <div :class="['arrow-unfold',{'arrow':isUnfoldDiscuss}]"></div>
                </div>
            </div>
            <!-- 其他评价 -->
            <!-- <div class="other-panel">
                <div class="top-box">
                    <div class="title">其它用户评价（{{ nOtherDiscuss || 0 }}）</div>
                    <div class="more" @click="toMoreDiscuss">查看全部</div>
                </div>
                <div class="user-box">
                    <template v-for="item in otherInfo">
                        <div class="user-item">
                            <img :src="item.img" alt=""/>
                            <p>{{ item.name }}</p>
                        </div>
                    </template>
                    <div class="user-item" @click="toMoreDiscuss">
                        <img src="@/assets/images/project/v3/more_icon.png" alt=""/>
                        <p>更多</p>
                    </div>
                </div>
            </div>-->
        </template>
        <!-- 施工档案 -->
        <template v-if="type == 2">
            <div class="info-panel">
                <div class="title">施工档案</div>
                <!-- <template v-if="projectInfo.completed == 0">-->

                <template v-if="projectInfo.completed == 1">
                    <template v-for="(item,index) in projectInfo.report">
                        <div v-if="item.attach && item.attach.length > 0" class="work-box">
                            <div class="label">
                                <p>{{ item.title }}</p>
                                <div class="add-btn" @click="toAddImg(item)">添加图片</div>
                            </div>
                            <div class="img-content">
                                <template v-for="(attach,attach_i) in item.attach">
                                    <img :src="attach.image_url"
                                         :class="(nAttachIndex[0] == index && nAttachIndex[1] == attach_i)?'img_act':''"
                                         alt="" @click="toImg(attach,index,attach_i)">
                                </template>
                            </div>
                            <div class="item-content">
                                <div class="item-box">
                                    <template v-for="cate in item.cate_list">
                                        <div class="item">{{ cate }}</div>
                                    </template>
                                </div>
                                <img src="@/assets/images/project/v3/qualified.png" alt="">
                            </div>
                            <div v-if="item.report && item.report.length > (index + 1)" class="split"></div>
                        </div>
                    </template>
                </template>
                <template v-if="projectInfo.completed == 0">
                    <template v-for="(item,index) in projectInfo.item">
                        <div v-if="item.attach && item.attach.length > 0" class="work-box">
                            <div class="label">
                                <p>{{ item.title }}</p>
                                <!--  <div class="more-box" @click="toLookWord(1,item.id)">点击查看</div>-->
                            </div>
                            <div class="img-content">
                                <template v-for="(attach,index) in item.attach">
                                    <img :src="attach.image_url">
                                    <!--   alt="" @click="toPreview2(item.attach,index)-->
                                </template>
                            </div>
                        </div>
                    </template>
                </template>
                <!--  <template v-if="true">
                    <template v-for="(item,index) in projectInfo.item">
                        <div v-if="item.attach && item.attach.length > 0" class="work-box">
                            <div class="label">
                                <p>{{ item.title }}</p>
                                &lt;!&ndash;   <div class="more-box" @click="toLookWord(1,item.id)">点击查看</div>&ndash;&gt;
                            </div>
                            <div class="img-content">
                                <template v-for="(attach,attach_i) in item.attach">
                                    <img :src="attach.image_url"
                                         :class="(nAttachIndex[0] == index && nAttachIndex[1] == attach_i)?'img_act':''"
                                         alt="" @click="toImg(item,index,attach_i)">
                                </template>
                            </div>
                            <div v-if="item.cate_list && item.cate_list.length > 0" class="item-content">
                                <div class="item-box">
                                    <template v-for="cate in item.cate_list">
                                        <div class="item">{{ cate }}</div>
                                    </template>
                                </div>
                                <img src="@/assets/images/project/v3/qualified.png" alt="">
                            </div>
                        </div>
                    </template>
                </template>-->
            </div>
        </template>
        <!-- 服务团队 -->
        <!--
        <div class="info-panel">
                    <div class="title">服务团队</div>
                    <div class="team-box">
                        <template v-for="item in projectInfo.servicer">
                            <div class="team-item">
                                <img
                                    :src="item.icon"
                                    alt="">
                                <div class="team-info">
                                    <div class="info-box">
                                        <p>{{ item.name }}</p>
                                        <p v-if="item.job_number">工号:{{ item.job_number }}</p>
                                        <p>项目经验：{{ item.num }}户</p>
                                    </div>
                                    <div class="position">
                                        {{ item.group_name }}:
                                        {{ item.desc }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                &lt;!&ndash; 了解更多 &ndash;&gt;
                <div class="more-panel">
                    <div class="title">了解更多</div>
                    <div class="product arrow" @click="toMoreProduct">
                        <div class="product-link">
                            <img src="@/assets/images/project/v3/product_link.png" alt="">
                            产品详情
                        </div>
                        <img class="product_pic" src="@/assets/images/project/v3/product_pic.png" alt="">
                        <div class="text">
                            <p>A.O.史密斯 AI-LiNK</p>
                            <p>好风好水 智慧集成</p>
                        </div>

                    </div>
                    <div class="case arrow" @click="toMoreCase">
                        <img src="@/assets/images/project/v3/case_icon.png" alt="">
                        <div class="text">
                            更多案例
                        </div>
                    </div>
                </div>
                <img class="bottom-bg" src="@/assets/images/project/v3/bottom_bg.png"></img>
                &lt;!&ndash; 直销员进入详情页展示直销信息，分享详情页展示分享人信息 &ndash;&gt;
                <div v-if="(mode == '1' && isZxy) || mode == '2'" :class="['staff-panel',{'staff-panel2':mode == '1'}]">
                    <div class="staff-box">
                        <img class="head" :src="projectInfo.qyuser.headimgurl || '@/assets/images/project/v3/staff_head.png'"
                             alt=""></img>
                        <div class="name">{{ projectInfo.qyuser.nickname || '王小姐' }}</div>
                        <div class="position">高级服务顾问</div>
                        <img :src="projectInfo.qyuser.qrcode" class="qrcode"></img>
                    </div>
                </div>
                &lt;!&ndash; 直销员进入详情页，才有分享 &ndash;&gt;
                <template v-if="mode == '1' && isZxy">
                    <div class="operate-panel">
                        <div class="btn" @click="toSTar">
                            <img src="@/assets/images/project/v3/star_line.png" alt="">
                            收藏
                        </div>
                        <div class="btn btn-blue" @click="toShare">
                            <img src="@/assets/images/project/v3/share_pic.png" alt="">
                            分享
                        </div>
                    </div>
                </template>-->
        <sharePanel :show="isShowSharePopup" :shareConfig="shareConfig" :projectId="projectInfo.pro_name"
                    @close="isShowSharePopup = false"></sharePanel>
        <media-preview :show="isShowPreview" :nIndex="nPreviewIndex" :arrUrl="arrPreview"
                       @close="closePreview"></media-preview>
    </div>
</template>

<script>
import {Rate} from 'vant';
import mediaPreview from '../components/preview/index.vue';
import sharePanel from '../components/sharePanel/index.vue';
import URLAPI from "@/libsV2/urlApi";
import {getCasePrevirew2, getDiscussPrevirew} from "@/js/project/v3/index.js";


export default {
    name: "caseDetails",
    components: {
        vantRate: Rate,
        sharePanel,
        mediaPreview
    },
    data() {
        return {
            type: null, //1 - 施工档案， 2 - 案例评论
            projectId: '',
            userInfo: {},
            projectInfo: {
                qyuser: {}
            },
            isShowDiscuss: false,
            discussMsg: '',
            discussInfo: {},
            isUnfoldDiscuss: false,
            isShowUnfold: true,
            //其他评论的用户信息
            nOtherDiscuss: 0,
            otherInfo: [],
            isShowPreview: false,
            nPreviewIndex: 0,
            arrPreview: [],
            isShowSharePopup: false,
            prevAudio: {
                key: '',
                el: null,
            },
            shareConfig: {},
            isZxy: false,
            nAttachIndex: [-1, -1]
        }
    },
    mounted() {
        this.type = this.$route.query.type;
        this.projectId = this.$route.query.id;
        this.project_uuid = this.$route.query.uuid;
        this.pageInt()
    },
    methods: {
        pageInt() {
            if (this.type == 1) {
                this.getDiscussFun()
            } else if (this.type == 2) {
                this.getCasePrevirewFun()
            }
        },
        getDiscussFun() {
            return new Promise((resolve, reject) => {
                getDiscussPrevirew({
                    project_uuid: this.projectId,
                }).then((res) => {
                    console.log(res)
                    let data = res.data.data.result;
                    if (data.lists.length > 0) {
                        this.isShowDiscuss = true;
                        this.discussMsg = data.desc.poster_title;
                        let userInfo = {
                            img: data.lists[0].headimgurl,
                            name: data.lists[0].nickname,
                            time: data.lists[0].updated_at ? data.lists[0].updated_at.split(' ')[0].replaceAll('-', '.') : ''
                        }
                        this.userInfo = userInfo;
                        let discussList = data.lists;
                        let discussInfo = {
                            sgInfo: '',
                            jgInfo: '',
                            zpInfo: ''
                        };

                        discussList.forEach((it) => {
                            if (it.is_completed == 3) {
                                discussInfo.sgInfo = {
                                    score: it.score,
                                    score_num: Number(it.score),
                                    content: it.content,
                                    pic: it.pic,
                                    voice_time: it.voice_time,
                                    voice: it.voice,
                                    time: it.created_at ? it.created_at.split(' ')[0].replaceAll('-', '.') : '',
                                    isOpenVoice: false //是否开始播放音频
                                };
                            } else {
                                discussInfo.jgInfo = {
                                    score: it.score,
                                    score_num: Number(it.score),
                                    content: it.content,
                                    pic: it.pic,
                                    voice_time: it.voice_time,
                                    voice: it.voice,
                                    time: it.created_at ? it.created_at.split(' ')[0].replaceAll('-', '.') : '',
                                    isOpenVoice: false //是否开始播放音频
                                }
                                if (it.content2 && it.zhui_time) {
                                    discussInfo.zpInfo = {
                                        content: it.content2,
                                        pic: it.pic_zhui,
                                        time: it.zhui_time ? it.zhui_time.split(' ')[0].replaceAll('-', '.') : '',
                                    }
                                }
                            }
                        })

                        if (discussInfo.sgInfo && !discussInfo.jgInfo && !discussInfo.zpInfo) {
                            this.isUnfoldDiscuss = true;
                            this.isShowUnfold = false;
                        } else {
                            this.isUnfoldDiscuss = true;
                            this.isShowUnfold = true;
                        }
                        this.discussInfo = discussInfo;
                    } else {
                        this.isShowDiscuss = false;
                    }
                    resolve()
                })
            })
        },
        getCasePrevirewFun() {
            this.$store.commit("loadSwitch", true);
            return new Promise((resolve, reject) => {
                getCasePrevirew2({
                    project_id: this.projectId,
                    project_uuid: this.project_uuid
                }).then((res) => {
                    let data = res.data.data.result;
                    if (data.completed == 1 && data.report && data.report.length > 0) {
                        this.isShowWork = true;
                        data.report.forEach((it) => {
                            it.title = it.title.replaceAll('监理报告', '')
                        })
                    } else if (data.completed == 0 && data.item && data.item.length > 0) {
                        this.isShowWork = true;
                        data.item.forEach((it) => {
                            it.attach = []
                            if (it.children && it.children.length > 0) {
                                it.children.forEach((children) => {
                                    it.attach.push(...children.images)
                                })
                            }
                        })
                    }
                    this.$store.commit("loadSwitch", false);

                    this.projectInfo = data;
                    resolve()
                }).catch(() => {
                    window.parent.postMessage({
                        key: 'caseNot',
                    }, '*')
                })
            })
        },
        checkZxyFun() {
            return new Promise((resolve, reject) => {
                checkZxy().then((res) => {
                    this.isZxy = res.data.data.result;
                    resolve()
                })
            })
        },
        getOtherDiscussFun() {
            return new Promise((resolve, reject) => {
                getCaseDiscussList({
                    project_uuid: this.projectInfo.pro_name,
                    page: 0,
                    limit: 5,
                    type: 'all',
                    sort: 'id',
                    sort_type: 'desc',
                }).then((res) => {
                    let data = res.data.data.result;
                    let info = [];
                    if (data.total_num >= 1) {
                        data.lists.forEach((it) => {
                            let item = it[0];
                            info.push({
                                img: item.headimgurl,
                                name: `${item.nickname.slice(0, 1) + '*'}${item.nickname.length >= 3 ? item.nickname.slice(-1) : ''}`,
                            })
                        })
                    }
                    this.nOtherDiscuss = data.total_num;
                    this.otherInfo = info;
                    resolve()
                })
            })
        },
        //获取时间差
        computTime(oldTime) {
            if (oldTime == null && oldTime == undefined) {
                return '1天'
            }
            let nowTime = new Date().getTime();  //现在时间 时间戳
            let endTime = oldTime.replace(/-/g, '/');
            let zhuiTime = new Date(endTime);
            zhuiTime = zhuiTime.getTime();
            let diffTime = (nowTime - zhuiTime) / 1000
            let timeData = ''

            if (diffTime < 0) {
                timeData = '1天'
            } else if (0 < diffTime && diffTime < 86400) {
                timeData = '1天'
            } else if (86400 < diffTime && diffTime < 2592000) {
                timeData = parseInt(diffTime / 86400) + '天'
            } else if (2592000 < diffTime && diffTime < 31536000) {
                timeData = parseInt(diffTime / 2592000) + '个月'
            } else {
                timeData = parseInt(diffTime / 31536000) + '年'
            }

            return timeData
        },
        closePreview() {
            this.isShowPreview = false;
        },
        toPreview(arr, i) {
            this.arrPreview = arr;
            this.nPreviewIndex = i;
            this.isShowPreview = true;
        },
        toImg(item, i, attach_i) {
            if (item.state == 1) {
                this.$set(this, 'nAttachIndex', [i, attach_i])
                let data = {
                    img: item
                }
                window.parent.postMessage({
                    key: 'editImg',
                    data: data
                }, '*')
            } else {
                this.$toast("该图片为标准图，无法修改");
                window.parent.postMessage({
                    key: 'editNot',
                }, '*')
            }
        },
        toUnfold() {
            this.isUnfoldDiscuss = !this.isUnfoldDiscuss;
        },
        toSTar() {
            this.$toast("此功能暂未开放");
        },
        toMoreProduct() {
            let param = process.env.VUE_APP_FLAG == 'production' ? `id=73&itemid=930&name=1980&project_uuid=${this.$route.query.project_uuid}` : `type=package&id=136&project_uuid=${this.$route.query.project_uuid}`;
            window.location.href = `${URLAPI.URL5}comm/scan/jumpurl?path=goods&params=${encodeURIComponent(param)}`;
        },
        toMoreCase() {
            this.$router.replace({
                path: '/project/v3/case/index'
            })
        },
        toMoreDiscuss(item) {
            this.$router.push({
                path: `/project/v3/discuss/index?id=${this.projectInfo.pro_name}`
            })
        },
        toLookWord(type, id) {
            this.$router.push({
                path: `/project/v3/word/preview?id=${id}&projectId=${this.projectInfo.id}`
            })
        },
        toShare() {
            this.isShowSharePopup = true;
        },
        playAudio(key, ref) {
            let info = this.discussInfo[key];
            let el = this.$refs[ref];

            if (this.prevAudio.key && this.prevAudio.key != key) {
                this.prevAudio.el.pause();
                this.prevAudio.el.load();
                this.discussInfo[this.prevAudio.key].isOpenVoice = false;
            }

            this.prevAudio.el = el;
            this.prevAudio.key = key;

            if (info.isOpenVoice) {
                info.isOpenVoice = false;
                el.pause();
                el.load();
            } else {
                info.isOpenVoice = true;
                el.play()
            }
        },
        onAudioEnd(key) {
            let info = this.discussInfo[key];
            info.isOpenVoice = false;
        },
        toAddImg(item) {
            this.$set(this, 'nAttachIndex', [-1, -1])
            let data = {
                item: item
            }
            window.parent.postMessage({
                key: 'addImg',
                data: data
            }, '*')
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./details.scss";

.details-wrap {
    border-radius: 0 0 50px 50px;

    .info-panel {
        margin-bottom: calc(20px + env(safe-area-inset-bottom));
    }

    .add-btn {
        font-size: 24px;
        margin-right: 40px;
    }

}

.details-wrap::-webkit-scrollbar {
    display: none;
}
</style>
